<template>
  <div
    class="navi-notification-list-container"
    @click="(e) => e.stopPropagation()"
  >
    <div class="navi-notification-list-filter">
      所有通知
    </div>

    <div class="navi-notification-list">
      <template v-if="isNotificationsEmpty && isNotificationsReachEnd">
        <div class="navi-notification-list-empty-hint">
          <i class="navi-notification-list-empty-hint-icon icon-font-bell" />
          目前沒有任何通知
        </div>
      </template>
      <template v-else>
        <NotificationListItem
          v-for="item in notificationsData.items"
          :key="item.id"
          :notification="item"
        />
        <div
          ref="infiniteTriggerElement"
          class="navi-notification-loading-hint"
        >
          {{ isNotificationsReachEnd ? '到底了' : '載入通知中...' }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import { requestResetUninspectedCount } from '@/api/notification'

import useInfiniteScroll from '../composables/useInfiniteScroll'
import useGetNotificationsData from '../composables/useGetNotificationData'

import NotificationListItem from './NaviNotificationListItem.vue'

const props = defineProps({
  hasUninspectedCount: {
    type: Boolean,
    required: true,
  },
  resetUninspectedCount: {
    type: Function,
    required: true,
  },
})
const shouldResetUninspectedCount = ref(props.hasUninspectedCount > 0)

const { notificationsData, getNotificationsData } = useGetNotificationsData()

const isNotificationsEmpty = computed(() => (notificationsData.items.length === 0))
const isNotificationsReachEnd = computed(() => !notificationsData.pagination.hasMoreItems)

const infiniteTriggerElement = ref(null)
useInfiniteScroll({
  observeRef: infiniteTriggerElement,
  onIntersecting: () => {
    if (notificationsData.isLoading || isNotificationsReachEnd.value) {
      return
    }

    if (shouldResetUninspectedCount.value) {
      shouldResetUninspectedCount.value = false
      props.resetUninspectedCount()
      requestResetUninspectedCount()
    }

    getNotificationsData()
  },
})
</script>

<style scoped lang="scss">
.navi-notification-list-container {
  cursor: default;
  width: 480px;
  color: #434343;
  text-align: left;
}
.navi-notification-list-filter {
  padding: 9px 12px;
  border-bottom: 1px solid #dfdfdf;
  font-size: 13px;
}
.navi-notification-list {
  text-align: left;
  max-height: 442px;
  overflow: auto;
  overscroll-behavior: contain;
  background: #f5f5f5;
  border-bottom: 1px solid #dfdfdf;
}
.navi-notification-list-empty-hint {
  text-align: center;
  padding: 24px 12px;

  .navi-notification-list-empty-hint-icon {
    display:inline-block;
    width: 20px;
    height: 20px;
    font-size: 20px;
    position: static;
    margin: -3px 6px 0 0;
    vertical-align: middle;
    color: #636363;
  }
}
.navi-notification-loading-hint {
  text-align: center;
  padding: 12px;
  border-top: 1px solid #e9e9e9;
  margin-top: -1px;
  position: relative;
  background: #fff
}
</style>
